









































































import { FormFieldDefMap } from '@/reusable/Form/formUtils';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import CabeceraModal from '@/reusable/Modal/CabeceraModal.vue';
import ModalMantenedor from '@/reusable/Modal/ModalMantenedor.vue';
import { LoadingService } from '@/services/loadingService';
import { Snotify } from '@/snotify/Snotify';
import CrudStepsNavBar from '@/reusable/Mantenedor/CrudStepsNavBar.vue';
import { PasosCrud } from '@/reusable/Mantenedor/mantenedorUtils';
import ContenidoModal from '@/reusable/Modal/ContenidoModal.vue';
import { ServicioProxy } from '@/config/enums';
import { AxiosVue } from '@/AxiosVue';
import { fetchReportesSerie } from './fetchReporteSerie';
import moment from 'moment';
import TextField from '@/reusable/Form/TextField.vue';
import { actionsEvent } from '@/setup';
import { Funcionalidades } from '@/config/funcionalidades';
import config from '@/config/index';
import VerEditarModalInet from './verEditarModalInet.vue';
import {
  GridOptions,
  GridApi,
  ColumnApi,
  ColDef,
  GridReadyEvent,
  ICellRendererParams,
  RowNode,
} from 'ag-grid-community';
import MantenedorGridSinCodigo from '@/reusable/Grid/MantenedorGridSinCodigo.vue';
import MantenedorGrid from '@/reusable/Grid/MantenedorGrid.vue';
import { EstadoGrillaVm } from '@/interfaces/EstadoGrillaVm';
import { emit } from 'process';
@Component({
  components: {
    CabeceraModal,
    ModalMantenedor,
    CrudStepsNavBar,
    ContenidoModal,
    TextField,
    FormFieldsContainer,
    MantenedorGridSinCodigo,
    MantenedorGrid,
    VerEditarModalInet,
  },
})
export default class VerEditarModal extends Vue {
  @Prop({ default: true }) show: boolean;
  @Prop({ default: null }) codigoEquipo: any;
  @Prop({ default: null }) id_equipo: any;
  ocultar: boolean = false;
  respuesta: any;
  dictionaryFormErrors: any = {};
  plataformas: any = [];
  plataforma: any = null;
  tipoeqcuenta_inet: any = null;
  gridOptions: GridOptions;
  gridApi: GridApi;
  columnApi: ColumnApi;
  columnDefs: Array<ColDef> = [];
  estadoGrillaVm: EstadoGrillaVm;
  dialog2: boolean = false;
  serverSide: any;

  readonly $snotify: Snotify;
  readonly loadingService = new LoadingService();

  pasoActivoIndex = 1;
  readonly pasos: PasosCrud = {
    requerimiento: {
      accion: 'Editar Equipo',
      visible: true,
      step: 1,
      title: 'Editar Equipo',
      icon: 'ballot',
      formState: {
        entity: null,
        validator: null,
        isDirty: false,
      },
    },
  };

  readonly funcionalidad: Funcionalidades = Funcionalidades.EditarVehiculos;
  cambioEstado: boolean;
  estadoSelect: boolean;
  estadoInicial: boolean;

  async editar() {
    this.cambioEstado = false;
    this.respuesta = await this.$validator.validateAll();
    let self = this;
    this.loadingService.showLoading();
    return fetchReportesSerie(
      {
        tipoeqcuenta_inet: this.formFields.tipoeqcuenta_inet.value
          .toString()
          .toUpperCase(),
        tipoeq_cuentas_id: this.codigoEquipo.tipoeq_cuentas_id,
        tipoeqid: this.codigoEquipo.tipoeqid,
      },
      'conecta_matriz_producto/editar_cuentaInet'
    )
      .then((data: any) => {
        if (this.respuesta == false) {
          self.$snotify.error('EL formulario presenta errores.', {
            timeout: 3000,
          });
          return;
        }
        if (data.data.CODIGO_RESPUESTA == '1') {
          self.$snotify.success(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          this.handleCerrar();
          this.$emit('getCuentasInet');
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  formFields: FormFieldDefMap = {
    tipoeqcuenta_inet: {
      label: 'Cuenta Inet',
      id: '',
      value: '',
    },
    plataform: {
      label: 'plataforma',
      id: '',
      value: '',
    },
  };
  equipos_totales: any = [];
  async getEquipos() {
    let self = this;
    this.loadingService.showLoading();
    return fetchReportesSerie(
      {
        id: JSON.parse(localStorage.getItem('user')).id,
        equipoId: this.id_equipo,
      },
      'conecta_matriz_producto/s_crear_equipo'
    )
      .then(async (data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.equipos_totales = data.data.total_equipos.LISTA;
          this.plataformas = data.data.plataformas.LISTA;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        console.error(error);
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  mounted() {
    this.getEquipos();
    this.formFields.tipoeqcuenta_inet.value = this.codigoEquipo.tipoeqcuenta_inet;
    this.formFields.plataform.value = this.codigoEquipo.plataformaid;
    this.id_equipo = this.codigoEquipo.tipoeqid;
  }

  @Watch('ReporteSeleccionado')
  handleRutasSeleccionadas() {
    return;
  }

  handleCerrar() {
    this.$emit('cerrarCrear');
  }

  clearDevices() {
    this.plataforma = null;
    this.tipoeqcuenta_inet = null;
  }

  newList: Array<any> = [];
  alreadyReload: boolean = false;

  constructor() {
    super();
    actionsEvent.onEditar(this.handleEditarClick);
    let self = this;
  }

  handleEditarClick(params: ICellRendererParams) {
    this.codigoEquipo = params.data;
    this.dialog2 = true;
  }

  async handleCierreModalCrear() {
    this.dialog2 = false;
  }
}
